if (!customElements.get('quick-view-readmore')) {
  customElements.define(
    'quick-view-readmore',
    class QuickViewReadMore extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.quick-view__description-content');
        this.button = this.querySelector('.quick-view__readmore-btn');
        if (!this.content || !this.button) return;

        // Only show the toggle if the text actually overflows the clamped height.
        requestAnimationFrame(() => {
          if (this.content.scrollHeight <= this.content.clientHeight + 2) {
            this.button.hidden = true;
            this.classList.add('is-expanded');
          }
        });

        this.button.addEventListener('click', () => {
          const expanded = this.classList.toggle('is-expanded');
          this.button.textContent = expanded ? this.button.dataset.less : this.button.dataset.more;
        });
      }
    }
  );
}

if (!customElements.get('quick-view-modal')) {
  customElements.define(
    'quick-view-modal',
    class QuickViewModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickViewInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        fetch(`${opener.getAttribute('data-product-url')}?view=quick-view`)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const root = responseHTML.querySelector('.quick-view__root');
            if (!root) return;

            this.setInnerHTML(this.modalContent, root.outerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinject the script tags so they execute. Scripts are disabled when set via innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }
    }
  );
}
